import styled from 'styled-components'
import { rem } from 'polished'

import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'

import { ExperiencesHomepageCategoryStripToggleButton } from './ExperiencesHomepageCategoryStripToggle'

const CHIP_ICON_SIZE = 28

const ChipShell = styled.div`
  flex-shrink: 0;
`

const Chip = styled(ExperiencesHomepageCategoryStripToggleButton)`
  pointer-events: none;
  cursor: default;
  inline-size: 100%;
`

type Props = {
  width?: number
}

function ExperiencesHomepageBrowseCategoryChipSkeleton({ width }: Props) {
  return (
    <ChipShell
      style={width !== undefined ? { inlineSize: rem(width) } : undefined}
      data-testid="browse-category-chip-skeleton"
    >
      <Chip
        kind="secondary"
        orientation="horizontal"
        disabled
        startIcon={<LoadingBox width={CHIP_ICON_SIZE} height={CHIP_ICON_SIZE} borderRadius="S" />}
        title={
          <Group direction="vertical" gap={2}>
            <TextLoadingBox typography="body-medium" width={width ? width - 68 : 88} />
            <TextLoadingBox typography="caption-smallalt" width={width ? width - 88 : 64} />
          </Group>
        }
      />
    </ChipShell>
  )
}

export default ExperiencesHomepageBrowseCategoryChipSkeleton
